import siFetch from "api/fetch";

const offer = (init = null) => siFetch(`/api/v1/agent/offer`, init);

export default offer;
